import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export function Timepicker({
  label,
  disable,
  requiredField,
  error,
  fromForm,
  duplicatingItem,
  index,
  i,
  value,
  id,
  eleIndex,
  elekey,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  placeHolder,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };
  const timeSelectd = value ? new Date(value) : null;
  return (
    <div className="dt_picker position-relative" onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
      <label className={`asterisk-req ${fromForm && 'd-flex'}`}>
        {label}
        {requiredField && <span>*</span>}
      </label>
      <DatePicker
        key={`_${eleIndex}_${i}_${index}`}
        popperPlacement="top-end"
        name="selectedDate"
        showTimeSelect
        selected={timeSelectd}
        placeholderText={placeHolder}
        disabled={disable}
        timeIntervals={5}
        timeCaption="Time"
        timeFormat="HH:mm"
        dateFormat="HH:mm"
        onChange={(e) => onChange(e, label, i, eleIndex, index)}
        showTimeSelectOnly
      />
      <button type="button" className="btn-calender btn move_up">
        <i className="icon-clock" />
      </button>
      {fromForm && isOver && (
        <div className="potemp-action-btns">
          <button
            type="button"
            className="btn btn-border ml-auto  py-0 px-1"
            key={`_${eleIndex}_${i}_${index}_edit`}
            onClick={() => editingInput(index, i, eleIndex)}
          >
            <span className="icon-edit" />
          </button>
          {showDelete && isOver && (
            <button
              type="button"
              className="btn btn-border  py-0 px-1"
              key={`_${eleIndex}_${i}_${index}_delete`}
              onClick={() => deleteItem(index, i, elekey, eleIndex)}
            >
              <span className="icon-delete" />
            </button>
          )}
          <button
            type="button"
            className="btn btn-border  py-0 px-1"
            key={`_${eleIndex}_${i}_${index}_duplicate`}
            onClick={() => (fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey))}
          >
            <span className="icon-copy" />
          </button>
        </div>
      )}
      {error?.status && (
        <span key={`_${eleIndex}_${i}_${index}`} className="error-message">
          {error.errorMsg}
        </span>
      )}
    </div>
  );
}
export default Timepicker;
